import {
  CheckboxProps as MantineCheckboxProps,
  Checkbox as MantineCheckbox,
  CheckboxGroupProps as MantineCheckboxGroupProps,
  CheckboxGroup as MantineCheckboxGroup,
  CheckboxCardProps as MantineCheckboxCardProps,
  CheckboxCard as MantineCheckboxCard,
  CheckboxIndicatorProps as MantineCheckboxIndicatorProps,
  CheckboxIndicator as MantineCheckboxIndicator,
} from '@mantine/core';

export type CheckboxProps = MantineCheckboxProps;
export type CheckboxGroupProps = MantineCheckboxGroupProps;
export type CheckboxCardProps = MantineCheckboxCardProps;
export type CheckboxIndicatorProps = MantineCheckboxIndicatorProps;

export const Checkbox = MantineCheckbox;
Checkbox.displayName = 'Checkbox';

export const CheckboxGroup = MantineCheckboxGroup;
CheckboxGroup.displayName = 'CheckboxGroup';

export const CheckboxCard = MantineCheckboxCard;
CheckboxCard.displayName = 'CheckboxCard';

export const CheckboxIndicator = MantineCheckboxIndicator;
CheckboxIndicator.displayName = 'CheckboxIndicator';

// Attach subcomponents to Checkbox for dot notation access
Checkbox.Group = CheckboxGroup;
Checkbox.Card = CheckboxCard;
Checkbox.Indicator = CheckboxIndicator;
